module.exports = __webpack_public_path__ + "img/1_6.bb12b040.png";